import { useCallback } from 'react';
import { FieldPath, UseFormReturn } from 'react-hook-form';
import { CheckboxField } from '@brighte/form-components';
import { HouseholdType } from '@brighte/validation';
import { RepaymentField } from '@components/RepaymentField';
import { Field } from '@spark-web/field';
import { FinancialFieldTypes, HOUSEHOLD, LABELS } from '@utils';

type Props = Pick<UseFormReturn<HouseholdType>, 'watch' | 'control' | 'clearErrors'>;

function PartnerIncome({ watch, control, clearErrors }: Props) {
  const { NO_PARTNER_INCOME } = HOUSEHOLD;
  const { PARTNER_INCOME } = LABELS;

  const PARTNER_INCOME_FIELD = 'applicant.income.partnerIncome' as FieldPath<HouseholdType>;

  const [isPartnerIncomeNotApplicable, applicantPartnerIncomeAmount, applicantPartnerIncomePeriod] = watch([
    `${PARTNER_INCOME_FIELD}.isNotApplicable`,
    `${PARTNER_INCOME_FIELD}.amount`,
    `${PARTNER_INCOME_FIELD}.period`,
  ]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.value) {
        clearErrors(`${PARTNER_INCOME_FIELD}.amount`);
      }
    },
    [clearErrors],
  );

  return (
    <Field label={PARTNER_INCOME}>
      <RepaymentField
        control={control}
        periodFieldName={`${PARTNER_INCOME_FIELD}.period` as FieldPath<HouseholdType>}
        amountFieldName={`${PARTNER_INCOME_FIELD}.amount` as FieldPath<HouseholdType>}
        periodValue={applicantPartnerIncomePeriod}
        amountValue={applicantPartnerIncomeAmount}
        financialFieldType={FinancialFieldTypes.JOINT}
        disabled={isPartnerIncomeNotApplicable}
      />
      <CheckboxField
        name={`${PARTNER_INCOME_FIELD}.isNotApplicable`}
        control={control}
        label={NO_PARTNER_INCOME}
        onChange={handleChange}
      />
    </Field>
  );
}

export default PartnerIncome;
